var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{staticClass:"border-bottom mb-2",attrs:{"tabs":_vm.tabs}}),_c('div',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 150px)"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }